import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/debug-input")({
  component: DebugInput,
});

function logDebugInput(eventName: string) {
  console.info(`[GAMO_DIAG] debug-input ${eventName}`, {
    time: Number(performance.now().toFixed(2)),
    activeElement: document.activeElement?.tagName,
  });
}

function DebugInput() {
  console.info("[GAMO_DIAG] DebugInput render");

  return (
    <input
      id="debug-single-input"
      name="debug-single-input"
      type="text"
      style={{ margin: 24, padding: 8, border: "1px solid #999", width: 280 }}
    />
  );
}